import React from "react";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
import { ANALISIS_ESTADO_VALIDADO } from "../../../../../../../../utility/constants";
import { getAnalisisFromItem, getKgSecosLabFromItem } from "../../../../helpers/data";

export const ProcesoTable = ({ traslados, verDetalleTraslado }) => {
    return (
        <div className="new-table-wrapper listado-traslados__table-wrapper sticky-header sticky-first-column">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th rowSpan={2} className="cell-border-right">
                            TRASLADO
                        </th>
                        <th rowSpan={2} className="cell-border-right">
                            MATERIA PRIMA
                        </th>
                        <th colSpan={4} className="cell-border-right">
                            RECEPCIÓN EN ACOPIO
                        </th>
                        <th colSpan={4} className="cell-border-right">
                            RECEPCIÓN EN PLANTA
                        </th>
                        <th colSpan={2}>PROCESO</th>
                    </tr>
                    <tr>
                        {/* ACOPIO */}
                        <th>RECEPCIONES</th>
                        <th>KG HUMEDOS</th>
                        <th>DRC LABORATORIO</th>
                        <th className="cell-border-right">KG SECOS</th>

                        {/* PLANTA */}
                        <th>ID RECEPCIÓN</th>
                        <th>KG HUMEDOS</th>
                        <th>DRC LABORATORIO</th>
                        <th className="cell-border-right">KG SECOS</th>

                        {/* PROCESO PLANTA */}
                        <th>LABORATORIO</th>
                        <th>PESAJE</th>
                    </tr>
                </thead>
                <tbody>
                    {traslados.length === 0 && (
                        <tr>
                            <td colSpan={12} className="text-center">
                                No hay traslados en proceso.
                            </td>
                        </tr>
                    )}
                    {traslados.map((item) => {
                        const traslado = item.traslado ? item.traslado : {};
                        const resumen_origen_traslado =
                            item.resumen_origen_traslado
                                ? item.resumen_origen_traslado
                                : {};

                        const analisis = getAnalisisFromItem(item);
                        const kilosSecos = getKgSecosLabFromItem(analisis, item);

                        // Indica si el DRC del análisis fue validado
                        const analisisValidado =
                            analisis.estado == ANALISIS_ESTADO_VALIDADO;

                        return (
                            <tr key={item.id}>
                                {/* TRASLADO */}
                                <td
                                    className="text-center text-nowrap cell-border-right btn-link-pointer"
                                    onClick={() =>
                                        verDetalleTraslado(traslado.id)
                                    }
                                >
                                    {traslado.numero}
                                </td>
                                {/* MATERIA PRIMA */}
                                <td className="text-center text-nowrap cell-border-right">
                                    {item.materia_prima
                                        ? item.materia_prima.nombre
                                        : ""}
                                </td>
                                {/* ACOPIO */}
                                <td className="text-center text-nowrap listado-traslados__table-ellipsis-cell-v2">
                                    {resumen_origen_traslado.ids_ingreso}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            resumen_origen_traslado.kilos_humedos
                                        }
                                    >
                                        <RenderKilogramo
                                            value={
                                                resumen_origen_traslado.kilos_humedos
                                            }
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            resumen_origen_traslado.drc_laboratorio
                                        }
                                    >
                                        <RenderNumberPercentage
                                            value={
                                                resumen_origen_traslado.drc_laboratorio
                                            }
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    <NullableValue
                                        value={
                                            resumen_origen_traslado.kilos_secos_laboratorio
                                        }
                                    >
                                        <RenderKilogramo
                                            value={
                                                resumen_origen_traslado.kilos_secos_laboratorio
                                            }
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>

                                {/* PLANTA */}
                                <td className="text-center text-nowrap">
                                    {item.ingreso_display_id}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.kilos_humedos}>
                                        <RenderKilogramo
                                            value={item.kilos_humedos}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    {analisisValidado ? (
                                        <RenderNumberPercentage
                                            value={analisis.drc_final}
                                            decimalScale={3}
                                        />
                                    ) : (
                                        "—"
                                    )}
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    {analisisValidado ? (
                                        <RenderKilogramo
                                            value={kilosSecos}
                                            decimalScale={3}
                                        />
                                    ) : (
                                        "—"
                                    )}
                                </td>
                                {/* PROCESO */}
                                <td className="text-center text-nowrap">
                                    {analisisValidado ? (
                                        <span className="text-success font-weight-bold">
                                            LISTO
                                        </span>
                                    ) : (
                                        <span className="text-warning font-weight-bold">
                                            PENDIENTE
                                        </span>
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    {/* Si tiene kilos_humedos (total de pesos netos) ya fue pesado */}
                                    {item.kilos_humedos ? (
                                        <span className="text-success font-weight-bold">
                                            LISTO
                                        </span>
                                    ) : (
                                        <span className="text-warning font-weight-bold">
                                            PENDIENTE
                                        </span>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
